export const COLLAPSE_BREAKPOINT_PX = 1024

const USER_SETTINGS_KEY = 'userSettings'

/**
 * Read the persisted navbar collapse state straight from localStorage
 * (ngrx-store-localstorage persists the `userSettings` slice under its own
 * key). Synchronous by design: used before the sidebar's first paint so a
 * restored collapse doesn't animate expanded -> collapsed on boot.
 */
export function readNavbarCollapsedFromLocalStorage(): boolean | null {
  try {
    const raw = localStorage.getItem(USER_SETTINGS_KEY)
    if (!raw) return null
    const value = JSON.parse(raw)?.isNavBarCollapsed
    return typeof value === 'boolean' ? value : null
  } catch {
    return null
  }
}

/**
 * Read the persisted queue-panel collapse state straight from localStorage
 * (ngrx-store-localstorage persists the `userSettings` slice under its own
 * key). Synchronous by design: used before the inbox navbar's first paint so
 * a restored collapse doesn't animate expanded -> collapsed on boot.
 */
export function readQueuePanelCollapsedFromLocalStorage(): boolean | null {
  try {
    const raw = localStorage.getItem(USER_SETTINGS_KEY)
    if (!raw) return null
    const value = JSON.parse(raw)?.isQueuePanelCollapsed
    return typeof value === 'boolean' ? value : null
  } catch {
    return null
  }
}

/**
 * Read the away-modal-dismissed flag from the shared userSettings key in
 * localStorage. Shared between Angular and React so the modal doesn't
 * re-appear when navigating across the two apps.
 */
export function isAwayModalDismissed(): boolean {
  try {
    const raw = localStorage.getItem(USER_SETTINGS_KEY)
    if (!raw) return false
    return JSON.parse(raw)?.awayModalDismissed === true
  } catch {
    return false
  }
}

/**
 * Persist the away-modal-dismissed flag into the shared userSettings key
 * without clobbering other fields.
 */
export function setAwayModalDismissed(value: boolean): void {
  try {
    const raw = localStorage.getItem(USER_SETTINGS_KEY)
    const settings = raw ? JSON.parse(raw) : {}
    settings.awayModalDismissed = value
    localStorage.setItem(USER_SETTINGS_KEY, JSON.stringify(settings))
  } catch {
    // localStorage unavailable (private mode, etc.)
  }
}
